import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Button } from '@repo/ui/button';
import { Link } from 'react-router';

export const CheckEmailPage = () => {
  useLocale();

  return (
    <div className="w-screen max-w-lg px-4">
      <div className="w-full">
        <h1 className="font-semibold text-4xl">{t('auth.emailSent')}</h1>
        <p className="mt-2 mb-4 text-muted-foreground text-sm">
          {t('auth.aPasswordResetEmailHasBeenSentIfYou')}{' '}
        </p>
        <Button asChild>
          <Link to="/signin">{t('auth.returnToSignIn')}</Link>
        </Button>
      </div>
    </div>
  );
};
